export function getSlugFromPathname(pathname?: string): string | undefined {
  const path =
    pathname ?? (typeof window !== "undefined" ? window.location.pathname : "");
  const parts = path.split("/").filter(Boolean);
  return parts[0] === "search" ? parts[1] : parts[0];
}
